import { harborOrdersApiUrl, nonce } from '../utils/runtime';

function endpoint(path = '') {
  const base = harborOrdersApiUrl || '/wp-json/pfandpirat/v1/harbor/orders';
  return `${base}${path}`;
}

function headers(extra = {}) {
  return {
    'Content-Type': 'application/json',
    ...(nonce ? { 'X-WP-Nonce': nonce } : {}),
    ...extra,
  };
}

async function readJson(response) {
  const raw = await response.text();
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    throw new Error('Server-Antwort ist kein gültiges JSON.');
  }
}

async function request(url, options = {}) {
  const response = await fetch(url, {
    credentials: 'include',
    cache: options.method && options.method !== 'GET' ? undefined : 'no-store',
    ...options,
    headers: headers(options.headers || {}),
  });

  const payload = await readJson(response);

  if (!response.ok) {
    const message = payload?.message || payload?.data?.message || 'Freibeuterhafen-Auftrag konnte nicht verarbeitet werden.';
    const error = new Error(message);
    error.payload = payload;
    error.status = response.status;
    throw error;
  }

  return payload;
}

export function loadHarborOrders() {
  return request(endpoint());
}

export function loadActiveHarborOrder() {
  return request(endpoint('/active'));
}

export function acceptHarborOrder(orderId) {
  return request(endpoint(`/${orderId}/accept`), {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function claimActiveHarborOrder() {
  return request(endpoint('/active'), {
    method: 'POST',
    body: JSON.stringify({}),
  });
}
